import { useEffect } from "react";

const PrivacyPolicy: React.FC<{}> = () => {
  useEffect(() => {
    document.title = "Privacy Policy - OmMuse";
  }, []);
  return (
    <div className="container">
      <h1 className="settings-header">Privacy Policy</h1>
      <p>Last Modified: April 12, 2021</p>
      <ul>
        <li>
          <strong>
            <strong>Introduction</strong>
          </strong>
        </li>
      </ul>
      <p>
        OmMuse (&ldquo;OmMuse&rdquo;) is dedicated to protecting your personal
        information and informing you about how we use your personal
        information. This privacy policy applies to your use of the OmMuse
        Platform (as defined by the User Terms of Use). This Privacy Policy
        should be read in conjunction with the Creator Agreement and the User
        Terms of Use and is integrated into both agreements. All capitalized
        proper nouns not defined in this Privacy Policy will have the same
        definitions and meanings as defined by the User Terms of Use or the
        Creator Agreement. Please review this Privacy Policy periodically as we
        may revise it from time to time. If you do not agree with or accept our
        Privacy Policy in it&rsquo;s entirety, you must not access or use the
        Platform. If you use the Platform following a change to the terms of
        this Privacy Policy you agree to accept the revised policies.
      </p>
      <ul>
        <li>
          <strong>
            <strong>Information Collected</strong>
          </strong>
        </li>
      </ul>
      <p>
        At OmMuse, we collect personally identifiable information
        (&ldquo;PII&rdquo;) and non-personally identifiable
        (&ldquo;Non-PII&rdquo;) information from you. Personally identifiable
        information is information that can be used to identify you personally.
        Non-personally identifiable information is information that must be
        combined with other information to identify you personally.&nbsp;
      </p>
      <p>PII Collected</p>
      <p>
        You will not be required to provide us any information when you visit
        our Platform. However, in order to access or use some portions of the
        Platform, we may collect PII such as your name, additional identifying
        information, email, telephone number, personal details, date of birth,
        login and password information, address, and other relevant details. If
        you are a Creator in addition to that information we may collect your
        Creator name, Creator information, business address, and other relevant
        information related to any Creator Content. We may also collect your
        relevant payment or credit card information if you wish to pay for any
        services offered via the Platform. Please be aware that all payment
        information shall be stored and processed by our third party payment
        processors.
      </p>
      <p>Non-PII Collected</p>
      <p>
        Whenever you use our website, we may collect Non-PII from you, such as
        your IP address, zip code, browsing history, search history, and
        registration history, interactions with the Platform, usage information,
        location, referring URL, browser, operating system, data usage, data
        transferred, and Internet Service Provider.
      </p>
      <ol>
        <li>
          <strong>Use of Your Information</strong>
        </li>
      </ol>
      <p>
        Some of your information will be visible to other users of the Platform
        to facilitate communication. We will never sell your information without
        your permission; however you agree that we may use your information in
        the following ways:&nbsp;
      </p>
      <ul>
        <li>To provide any services offered and to operate OmMuse Platform.</li>
        <li>
          To enhance or improve our users&rsquo; experiences and share with
          other users of the Platform.
        </li>
        <li>
          To contact you via email or other electronic communications where you
          have an inquiry.
        </li>
        <li>To notify you of additional OmMuse services and updates.</li>
        <li>
          To share with third parties, with whom you have requested additional
          information relating to their products and services.
        </li>
        <li>
          To process your transactions and share information with other users of
          the Platform.
        </li>
        <li>
          To share your information with third party partners or third parties
          hired by us to perform functions and provide services to us subject to
          the obligations consistent with this Privacy Policy&nbsp;
        </li>
      </ul>
      <ul>
        <li>
          <strong>
            <strong>Accessing and Editing Your Information</strong>
          </strong>
        </li>
      </ul>
      <p>
        You will be able to access any information contained in your account
        through our Platform. You may edit that information by changing the
        information listed in your account. If you have any questions or wish to
        review, change, or access any of your information collected by us,
        please contact us at info@ommuse.com After you have cancelled your
        account please be aware that we may keep inaccessible copies of your PII
        and non-PII subject to our data retention policies.
      </p>
      <ul>
        <li>
          <strong>
            <strong>Cookies and Tracking</strong>
          </strong>
        </li>
      </ul>
      <p>
        We use cookies for authentication purposes and to remember you when you
        visit our Platform. If you disable cookies from your web browser some
        portions of our Platform may not work.
      </p>
      <ul>
        <li>
          <strong>
            <strong>Third Party Access to Your Information</strong>
          </strong>
        </li>
      </ul>
      <p>
        Although you are entering into an agreement with OmMuse to disclose your
        information to us, we do use third party individuals and organizations
        to assist us, including contractors, web hosts, and others to allow you
        to access the Platform.
      </p>
      <p>
        Throughout the course of our provision of our services to you, we may
        delegate our authority to collect, access, use, and disseminate your
        information. It is therefore necessary that you grant the third parties
        we may use in the course of our business the same rights that you afford
        us under this Privacy Policy. For this reason, you hereby agree that for
        every authorization which you grant to us in this Privacy Policy, you
        also grant to any third party that we may hire, contract, or otherwise
        retain the services of for the purpose of operating, maintaining,
        repairing, or otherwise improving or preserving our website or its
        underlying files or systems. You agree not to hold us liable for the
        actions of any of these third parties, even if we would normally be held
        vicariously liable for their actions, and that you must take legal
        action against them directly should they commit any tort or other
        actionable wrong against you.&nbsp;
      </p>
      <ul>
        <li>
          <strong>
            <strong>Law Enforcement</strong>
          </strong>
        </li>
      </ul>
      <p>
        You agree that we may disclose your information to authorities if
        compelled to by a court order. Additionally, you agree that we may
        disclose your information if we reasonably believe that you have
        violated US laws, the terms of our Terms of Use, the Creator Agreement,
        or our Privacy Policy, or if we believe that a third party is at risk of
        bodily or economic harm. In the event that we receive a subpoena
        affecting your privacy, we may elect to notify you to give you an
        opportunity to file a motion to quash the subpoena, or we may attempt to
        quash it ourselves, but we are not obligated to do either. We may also
        proactively report you and release your information without receiving
        any request to third parties where we believe that it is proper to do so
        for legal reasons, where your actions violate any law of the United
        States or any other country having jurisdiction over us, our Platform,
        our Creator Agreement, or our Terms of Use. You release us from any
        damages that may arise from or relate to the release of your information
        to a request from law enforcement agencies or private litigants. We may
        release your information under the conditions listed in this paragraph
        whether it is to individuals or entities and to any state or federal
        authorities, as required.
      </p>
      <ul>
        <li>
          <strong>
            <strong>
              Opt Out of Commercial, Non-Commercial Communications and Do Not
              Track
            </strong>
          </strong>
        </li>
      </ul>
      <p>
        If you decide to provide us with your contact information, you agree
        that we may send you communications via text and emails. However, you
        may unsubscribe from certain communications by notifying OmMuse that you
        no longer wish to receive these communications, we will endeavour to
        promptly remove you from our Platform once we have received that
        request. We currently do not offer functionality for you to opt out
        through &ldquo;do not track&rdquo; listings. If you wish to opt out of
        certain communications or information collection, please contact us at
        info@ommuse.com
      </p>
      <ul>
        <li>
          <strong>
            <strong>Third Parties</strong>
          </strong>
        </li>
      </ul>
      <p>
        &nbsp;Please be aware that some third party websites may be accessible
        via the Platform, when accessing a third party site through our
        Platform, you acknowledge that you are aware that these third party
        websites are not screened for privacy or security issues by us, and you
        release us from any liability for the conduct of these third party
        websites.
      </p>
      <p>
        Please be aware that this Privacy Policy, and any other policies in
        place, in addition to any amendments, does not create rights enforceable
        by third parties. OmMuse bears no responsibility for the information
        collected or used by any advertiser or third party website. You must
        review their policies to understand how their information collection
        practices work.
      </p>
      <ul>
        <li>
          <strong>
            <strong>Security Measures</strong>
          </strong>
        </li>
      </ul>
      <p>
        We make reasonable attempts to protect your information by using
        physical and electronic safeguards. However, as this is the Internet, we
        can make no guarantees as to the security or privacy of your
        information. For this reason, we recommend that you use anti-virus
        software, routine credit checks, firewalls, and other precautions to
        protect yourself from security and privacy threats.
      </p>
      <ul>
        <li>
          <strong>
            <strong>Your California Privacy Rights</strong>
          </strong>
        </li>
      </ul>
      <p>
        OmMuse permits residents of the State of California to use its Platform,
        and complies with the California Business and Professions Code
        &sect;&sect; 22575-22579. If you are a California resident you may
        request certain information regarding our disclosure of personal
        information to any third parties for their direct marketing purposes.
        Various provisions throughout this Privacy Policy address requirements
        of the Californian privacy statutes. Although we do not disseminate your
        information to third parties without permission, you must presume that
        we collect electronic information from all visitors. You may contact us
        at info@ommuse.com with any questions.
      </p>
      <ul>
        <li>
          <strong>
            <strong>Age Compliance</strong>
          </strong>
        </li>
      </ul>
      <p>
        We intend to fully comply with American and international laws
        respecting children&rsquo;s privacy including COPPA. Therefore, we do
        not collect or process any information for any persons under the age of
        13. If you are under 13 and using our Platform, please stop immediately
        and do not submit any information to us.
      </p>
      <ol>
        <li>
          <strong>International Transfer</strong>
        </li>
      </ol>
      <p>
        Your information may be transferred to - and maintained on - computers
        located outside of your state, province, country, or other governmental
        jurisdiction where the privacy laws may not be as protective as those in
        your jurisdiction. Your consent to this Privacy Policy followed by your
        submission of such information represents your agreement to that
        transfer. PII and Non-PII that is submitted to OmMuse will be collected,
        processed, stored, disclosed and disposed of in accordance with
        applicable U.S. law and this policy. If you are a non-U.S. member, you
        acknowledge and agree that OmMuse may collect and use your Information
        and disclose it to other entities outside your resident jurisdiction. In
        addition, such information may be stored on servers located outside your
        resident jurisdiction. U.S. law may not provide the degree of protection
        for information that is available in other countries.
      </p>
      <ul>
        <li>
          <strong>
            <strong>Merger and Acquisition</strong>
          </strong>
        </li>
      </ul>
      <p>
        In the event that OmMuse is involved in a bankruptcy, merger,
        acquisition, reorganization or sale of assets, your information may be
        sold or transferred as part of that transaction. Please be aware that
        once the information is transferred your privacy rights may change.
      </p>
      <ul>
        <li>
          <strong>
            <strong>Amendments</strong>
          </strong>
        </li>
      </ul>
      <p>
        Like our User Terms of Use, we may amend this Privacy Policy from time
        to time. When we amend this Privacy Policy, we will modify the date
        listed on this Privacy Policy or we may contact you. You must agree to
        the amendments as a condition of your continued use of our Platform. If
        you do not agree, you must immediately cease using our Platform and
        notify us of your refusal to agree by e-mailing us at info@ommuse.com
      </p>
    </div>
  );
};
export default PrivacyPolicy;
